"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayWallUtil = exports.CurrentPlan = void 0;
const DateUtil_1 = require("../../base/util/DateUtil");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class CurrentPlan {
    constructor() {
        this.itemId = "";
        this.name = "";
        this.value = "";
        this.isCancel = false;
        this.expiryDate = "";
        this.price = {
            amount: "",
            interval: "",
            interval_count: 0,
        };
    }
}
exports.CurrentPlan = CurrentPlan;
class PayWallUtil {
    static async currentPlan(preferencesStore, brainClient, webFeature) {
        const subscriptionId = await preferencesStore.getByKey(PayWallUtil.subscription_id_key);
        if (typeof subscriptionId === "string" && !(0, is_blank_1.default)(subscriptionId)) {
            const subscriptions = await brainClient.payWall.subscription(subscriptionId);
            const subscription = subscriptions.data.items?.data[0];
            if (subscription) {
                const targetPlan = await brainClient.payWall
                    .plans()
                    .then(res => res.data.find(plan => plan.id === subscription.price.product));
                if (targetPlan) {
                    const currentPlan = new CurrentPlan();
                    currentPlan.subscriptionId = subscriptionId;
                    currentPlan.itemId = subscription.id;
                    currentPlan.name = targetPlan.metadata.name;
                    currentPlan.value = targetPlan.metadata.value;
                    currentPlan.customer = subscriptions.data?.customer;
                    currentPlan.isCancel = subscriptions.data.cancel_at_period_end;
                    currentPlan.price = {
                        amount: subscription.price.unit_amount_decimal,
                        interval: subscription.price.recurring.interval,
                        interval_count: subscription.price.recurring.interval_count,
                    };
                    if (subscriptions.data.cancel_at && !(0, is_blank_1.default)(subscriptions.data.cancel_at)) {
                        currentPlan.expiryDate = DateUtil_1.DateUtil.formatDate(subscriptions.data.cancel_at * 1000);
                    }
                    return currentPlan;
                }
            }
        }
        const currentPlan = new CurrentPlan();
        const freePlan = webFeature.find(plan => plan.free);
        if (freePlan && !(0, is_blank_1.default)(freePlan)) {
            currentPlan.name = freePlan.name.text || "";
            currentPlan.value = freePlan.value;
        }
        return currentPlan;
    }
    static async getImagicaPlans(args) {
        let imagicaPlans = [];
        const freePlan = args.metadatas.find(metadata => metadata.free);
        if (freePlan) {
            freePlan.current_plan = args.currentPlan.value === freePlan.value;
            freePlan.current_plan_is_canceled = args.currentPlan.isCancel;
            freePlan.downgrade_button = freePlan.downgrade_button || {};
            //处理plan表格是否显示popup
            // if (showDowgradePopup && !isBlank(freePlan.downgrade_button) && !isBlank(currentPlan.customer)) {
            // freePlan.downgrade_button = { ...freePlan.downgrade_button, popup: downgradePopup[currentPlan.value] };
            // }
            imagicaPlans.push(freePlan);
        }
        for (const plan of args.stripePlans) {
            const target = args.metadatas.find(metadata => metadata.value === plan.metadata.value) ??
                args.metadatas.find(metadata => metadata.value === "pro");
            if (target && plan.active === true) {
                const targetPrices = await args.brainClient.payWall.planPrice(plan.id).then(res => res.data);
                const monthPrice = targetPrices.find(price => price.recurring.interval === "month");
                const annualPrice = targetPrices.find(price => price.recurring.interval === "year");
                target.price_month.priceId = monthPrice?.id;
                target.price_month.amount = monthPrice?.unit_amount_decimal;
                target.price_month.interval = monthPrice?.recurring.interval;
                target.price_month.interval_count = monthPrice?.recurring.interval_count;
                target.price_annual.priceId = annualPrice?.id;
                target.price_annual.amount = annualPrice?.unit_amount_decimal;
                target.price_annual.interval = annualPrice?.recurring.interval;
                target.price_annual.interval_count = annualPrice?.recurring.interval_count;
                target.current_plan = args.currentPlan.value === target.value;
                target.current_plan_is_canceled = args.currentPlan.isCancel;
                if (target.current_plan && args.currentPlan.isCancel && !(0, is_blank_1.default)(args.currentPlan.expiryDate)) {
                    target.expiryDate = args.currentPlan.expiryDate;
                }
                target.downgrade_button = target.downgrade_button || {};
                //处理plan表格是否显示popup
                // if (showDowgradePopup && !isBlank(target.downgrade_button) && !isBlank(currentPlan.customer)) {
                //  target.downgrade_button = { ...target.downgrade_button, popup: downgradePopup[currentPlan.value] };
                // }
                imagicaPlans.push(target);
            }
        }
        //按每月金额升序
        imagicaPlans.sort((a, b) => {
            let aAmountPreMonth = 0;
            let bAmountPreMonth = 0;
            if (!(0, is_blank_1.default)(a.price_month.amount) &&
                !(0, is_blank_1.default)(a.price_month.interval_count) &&
                !isNaN(Number(a.price_month.amount)) &&
                !isNaN(Number(a.price_month.interval_count))) {
                aAmountPreMonth = Number(a.price_month.amount) / Number(a.price_month.interval_count);
            }
            if (!(0, is_blank_1.default)(b.price_month.amount) &&
                !(0, is_blank_1.default)(b.price_month.interval_count) &&
                !isNaN(Number(b.price_month.amount)) &&
                !isNaN(Number(b.price_month.interval_count))) {
                bAmountPreMonth = Number(b.price_month.amount) / Number(b.price_month.interval_count);
            }
            return aAmountPreMonth - bAmountPreMonth;
        });
        //添加is_show_downgrage_button
        const currentPlanIndex = imagicaPlans.findIndex(x => x.value === args.currentPlan.value);
        imagicaPlans = imagicaPlans.map((x, index) => {
            return {
                ...x,
                is_show_downgrage_button: index < currentPlanIndex,
            };
        });
        return imagicaPlans;
    }
}
exports.PayWallUtil = PayWallUtil;
PayWallUtil.subscription_id_key = "imagica_creator_premium_subscription_id";
